define((require) => {
    "use strict";

    var Backbone       = require("backbone"),
        GuidelineModel = require("ui/editor/guideline/GuidelineModel");

    return Backbone.Collection.extend("GuidelineCollection", {
        model: GuidelineModel
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/guideline/GuidelineCollection.js